import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { EntryLayout } from '../../components/EntryLayout';
import { EntryField } from '../../components/EntryField';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';

/** MOB/Auth/CreateAccount. REQUIRES BACKEND: account creation and uniqueness checks. */
export function CreateAccount() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [consent, setConsent] = useState(false);
  const mismatch = confirm.length > 0 && confirm !== password;
  const ready = name.trim().length > 1 && username.trim().length > 2 && email.includes('@') && password.length >= 8 && !mismatch && confirm.length > 0 && consent;
  return <EntryLayout title={t('entry.create.title')} body={t('entry.create.body')} footer={<>
          <Button variant="gold" size="lg" fullWidth disabled={!ready} onClick={() => navigate('/confirmar-conta')} data-id="element-2364" data-mp="341lgd870s8h5">
            {t('entry.create.submit')}
          </Button>
          <p className="mt-2 text-center text-[12.5px] text-muted" data-id="element-2365" data-mp="m68aci7c8yn">
            {t('entry.create.hasAccount')}{' '}
            <button type="button" onClick={() => navigate('/entrar')} className="font-bold text-gold-deep underline decoration-gold/40 underline-offset-2" data-id="element-2366" data-mp="5jepa9rm66yb">
              {t('entry.create.login')}
            </button>
          </p>
        </>} data-id="element-2363" data-mp="3e1ug2w080c1a">
      <div className="space-y-3" data-id="element-2367" data-mp="jiehtsi8z5zr">
        <EntryField label={t('entry.create.name')} autoComplete="name" value={name} onChange={setName} data-id="element-2368" data-mp="oa5y9a7ovvc6" />
        <EntryField label={t('entry.create.username')} hint={t('entry.create.username.hint')} autoComplete="username" value={username} onChange={value => setUsername(value.replace(/\s+/g, '').toLowerCase())} data-id="element-2369" data-mp="y5wf45thcyc5" />
        <EntryField label={t('entry.create.email')} type="email" autoComplete="email" value={email} onChange={setEmail} data-id="element-2370" data-mp="k7g62885avqu" />
        <EntryField label={t('entry.create.password')} type="password" autoComplete="new-password" hint={t('entry.create.password.hint')} value={password} onChange={setPassword} data-id="element-2371" data-mp="ah3mai85n6lr" />
        <EntryField label={t('entry.create.confirm')} type="password" autoComplete="new-password" value={confirm} onChange={setConfirm} error={mismatch ? t('entry.create.mismatch') : undefined} data-id="element-2372" data-mp="1hqf5w7i6u47" />
      </div>

      <label className="mt-3 flex items-start gap-2 rounded-card border border-sand-line bg-white/60 p-2" data-id="element-2373" data-mp="2349rvs1i3w7g">
        <input type="checkbox" checked={consent} onChange={event => setConsent(event.target.checked)} className="mt-[3px] h-[18px] w-[18px] shrink-0 accent-[var(--bee-gold)]" data-id="element-2374" data-mp="2834ivh9mgr2n" />
        <span className="text-[12.5px] leading-relaxed text-deep" data-id="element-2375" data-mp="2h2zzi1ly5ea2">
          {t('entry.create.consent')}
        </span>
      </label>

      <p className="mt-2 flex items-start gap-2 text-[11.5px] leading-snug text-muted" data-id="element-2376" data-mp="1pdof8l2n4ii0">
        <ShieldCheckIcon size={14} className="mt-[1px] shrink-0 text-gold" aria-hidden="true" data-id="element-2377" data-mp="1tfji3u07z3xw" />
        {t('entry.create.consentNote')}
      </p>
    </EntryLayout>;
}